var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaregularidbadge58260C9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_582_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 0H2.25C1.00781 0 0 1.00781 0 2.25V21.75C0 22.9922 1.00781 24 2.25 24H15.75C16.9922 24 18 22.9922 18 21.75V2.25C18 1.00781 16.9922 0 15.75 0ZM15.75 21.75H2.25V2.25H15.75V21.75ZM6.75 5.25H11.25C11.6625 5.25 12 4.9125 12 4.5C12 4.0875 11.6625 3.75 11.25 3.75H6.75C6.3375 3.75 6 4.0875 6 4.5C6 4.9125 6.3375 5.25 6.75 5.25ZM9 13.5C10.6547 13.5 12 12.1547 12 10.5C12 8.84531 10.6547 7.5 9 7.5C7.34531 7.5 6 8.84531 6 10.5C6 12.1547 7.34531 13.5 9 13.5ZM4.8 19.5H13.2C13.7813 19.5 14.25 19.0969 14.25 18.6V17.7C14.25 16.2094 12.8391 15 11.1 15C10.5938 15 10.2234 15.375 9 15.375C7.73906 15.375 7.43437 15 6.9 15C5.16094 15 3.75 16.2094 3.75 17.7V18.6C3.75 19.0969 4.21875 19.5 4.8 19.5V19.5Z",
    fill: "#3E3E3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_582_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaregularidbadge58260C9);
export default __webpack_public_path__ + "static/media/faregularidbadge5826-0c9.353eaa8866d6ae10e7f0b2c3bec31d3f.svg";
export { ForwardRef as ReactComponent };